// extracted by extract-css-chunks-webpack-plugin
module.exports = {"search-input":"_2HXEct","input":"_3KFtL4","search-input-container":"_30i5f1","search-button":"_2Ndycv","typeahead-result":"_2uDPwf"};